import { render } from "./NewRestaurant.vue?vue&type=template&id=28315a12&scoped=true"
import script from "./NewRestaurant.vue?vue&type=script&lang=js"
export * from "./NewRestaurant.vue?vue&type=script&lang=js"

import "./NewRestaurant.vue?vue&type=style&index=0&id=28315a12&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28315a12"]])

export default __exports__